import { Card, CardContent, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@material-ui/core'
import React from 'react'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { choicesState, loadingState, predictionState, whenAnsweredState } from '../atoms'
import { predict } from '../utils'


const ActivityQuestion = props => {
    const [choices, setChoices] = useRecoilState(choicesState)
    const [predictions, setPredictions] = useRecoilState(predictionState)
    const [whenAnswered, setWhenAnswered] = useRecoilState(whenAnsweredState)
    const setLoading = useSetRecoilState(loadingState)
    const handleChange = async event => {
        setLoading(true)
        let activityChoices = [...choices.activities]
        if (activityChoices[props.id] === 0) {
            let whenAnsweredActivitiesPredictions = [...whenAnswered.activities]
            whenAnsweredActivitiesPredictions[props.id] = predictions.activities[props.id]
            setWhenAnswered({
                activities: whenAnsweredActivitiesPredictions,
                tenPersonalItemInventory: whenAnswered.tenPersonalItemInventory,
                wordDefinitions: whenAnswered.wordDefinitions
            })
        }
        activityChoices[props.id] = Number(event.target.value)
        setChoices({
            activities: activityChoices,
            tenPersonalItemInventory: choices.tenPersonalItemInventory,
            wordDefinitions: choices.wordDefinitions
        })
        const [activitiesPrediction, tenPersonalItemInventoryPrediction, wordDefinitionsPrediction] = await predict(activityChoices, choices.tenPersonalItemInventory, choices.wordDefinitions)
        setPredictions({
            activities: activitiesPrediction,
            tenPersonalItemInventory: tenPersonalItemInventoryPrediction,
            wordDefinitions: wordDefinitionsPrediction
        })
        setLoading(false)
    }
    const predictionText = () => {
        let prediction = predictions.activities[props.id] * 5
        if (whenAnswered.activities[props.id] !== 0)
            prediction = whenAnswered.activities[props.id] * 5
        let text = String(prediction)
        switch (Math.round(prediction)) {
            case 1:
                text += " (Dislike)"
                break;
            case 2:
                text += " (Slightly dislike)"
                break;
            case 3:
                text += " (Neutral)"
                break;
            case 4:
                text += " (Slightly enjoy)"
                break;
            case 5:
                text += " (Enjoy)"
                break;
            default:
                break;
        }
        return text
    }
    return (
        <Card variant='elevation' style={{ marginTop: '20px' }}>
            <CardContent>
                <Typography>
                    {props.id + 1} - {props.question}
                </Typography>
                <Grid container>
                    <Grid xs={6} item>
                        <FormControl component='fieldset'>
                            <RadioGroup value={String(choices.activities[props.id])} onChange={handleChange}>
                                <FormControlLabel value="0" control={<Radio />} label="Unselected" />
                                <FormControlLabel value="1" control={<Radio />} label="1- Dislike" />
                                <FormControlLabel value="2" control={<Radio />} label="2- Slightly dislike" />
                                <FormControlLabel value="3" control={<Radio />} label="3- Neutral" />
                                <FormControlLabel value="4" control={<Radio />} label="4- Slightly enjoy" />
                                <FormControlLabel value="5" control={<Radio />} label="5- Enjoy" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid xs={6} item style={{ textAlign: 'center', alignSelf: 'center' }}>
                        <Typography style={{ color: 'red', fontStyle: 'italic' }}>
                            Predicted: {predictionText()}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default ActivityQuestion